import { encode as base64_encode } from "base-64";
import { postApi,baseURL } from "../components/Utility";
import {
  action,
  makeObservable,
  observable
} from "mobx";
import { message } from "antd";

class GeofenceSummaryStore {
  total ="";
  geofenceSummaryStore = [];
  geofenceSummary=[];
  rootStore;
  loading=false
  loadingData=false
  remaning_vehicleId = ""
  last_record_timestamp = ""
  pythonReportErrorMessage= false
  pythonReportMessage = false

  constructor(rootStore) {
    makeObservable(this, {
      total: observable,
      geofenceSummaryStore: observable,
      loadingData:observable,
      loadData: action,
      exportpdf:action,
      exportExcel:action,
      exportcsv:action,
      exportxml:action,
      loading:observable,
      geofenceSummary:observable,
      loadGeofenceSummaryData:action,
      remaning_vehicleId: observable,
      last_record_timestamp: observable,
      pythonReportMessage: observable,
      pythonReportErrorMessage:observable


    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, vehicleId, offset, limit, fromDate, toDate }) {
    console.log("vehicle list");
    this.loading=true
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: 1,
    };

    if (offset === 0) {
      postData.last_record_timestamp = ""
      postData.remaning_vehicleId = ""
    } else {
      postData.last_record_timestamp = this.last_record_timestamp
      postData.remaning_vehicleId = this.remaning_vehicleId
    }
    var response = await postApi.getClient().post("/alert_report/geofenceSummary", postData);
    // this.total = 500
    this.last_record_timestamp = response?.data?.data?.last_record_timestamp
    this.remaning_vehicleId = response?.data?.data?.remaning_vehicleId
    this.geofenceSummaryStore = response?.data?.data?.geofencesummary;
    // this.total = parseInt(response?.data?.data?.TotalCount);
    // console.log(this.total)
    this.loading=false
  }


  async loadGeofenceSummaryData({ companyId, vehicleId, offset, limit, fromDate, toDate }) {
    console.log("vehicle list");
    this.loadingData=true
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=geosummtotal", "postData=" + base64Input);

    console.log(response?.data?.data);
    this.geofenceSummary = response?.data?.data;
    // this.total = parseInt(response?.data?.data?.TotalCount);
    // console.log(this.total)
    this.loadingData=false
  }

  
  async exportExcel(getData) {

      getData = { ...getData, language: "english" }
      
      try {

        await postApi.getClient().post("/alert_report/geofenceSummary/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.")
      }
    
  }

  async exportpdf(getData) {

      getData = { ...getData, language: "english" }
     
      try {

        await postApi.getClient().post("/alert_report/geofenceSummary/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.")
      }

  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportgeosumcsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      // "&int=" +
      // getData.intervel +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportgeosumxml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      // "&int=" +
      // getData.intervel +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
}

export default GeofenceSummaryStore;
